import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CreateUpdateShiftTemplateEntity } from '../../domain/entities/CreateUpdateShiftTemplate'
import moment from 'moment'
import { dayOfWeekOrder } from '@/shared/enums/DayOfWeekOrder'

export class CreateUpdateShiftTemplateModel extends CreateUpdateShiftTemplateEntity {
  startTime?: string
  duration?: string
  regionId?: number
  constructor(dataDto: CreateUpdateShiftTemplateEntity) {
    super()
    const startTimeDayOfWeekUtc = moment(dataDto.startTimeDate).utc().format('dddd')
    const startTimeDayOfWeek = moment(dataDto.startTimeDate).format('dddd')
    const previousStartTimeDayOfWeek =
      dayOfWeekOrder[dayOfWeekOrder.findIndex((day) => day === dataDto.dayOfWeek!) - 1] ||
      dayOfWeekOrder[dayOfWeekOrder.length - 1]
    mapEntityProperties<CreateUpdateShiftTemplateModel>(this, dataDto, {
      exclude: ['region', 'startTimeDate', 'durationDate'],
      map: {
        startTime: dataDto.startTimeDate
          ? moment.utc(dataDto.startTimeDate).format('HH:mm:00')
          : '',
        duration: dataDto.durationDate ? moment(dataDto.durationDate).format('HH:mm:00') : '',
        startTimeDayOfWeek:
          startTimeDayOfWeekUtc === startTimeDayOfWeek
            ? dataDto.dayOfWeek
            : previousStartTimeDayOfWeek,
        regionId: dataDto.region?.id
      }
    })
  }
}
